import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	feedbackTitle: {
		id: 'smart-create-feedback.feedback-title',
		defaultMessage: 'Help us improve Create with Rovo',
		description: 'Title of a modal for providing feedback on the Create with Rovo feature.',
	},
	rateExperience: {
		id: 'smart-create-feedback.emoji-rating-selector.label',
		defaultMessage: 'Please rate your experience with Create with Rovo:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for the Create with Rovo feature.',
	},
	feedbackTitleNoCreate: {
		id: 'smart-create-feedback.feedback-title-no-create',
		defaultMessage: 'Help us improve Rovo',
		description: 'Title of a modal for providing feedback on Rovo page editing.',
	},
	rateExperienceNoCreate: {
		id: 'smart-create-feedback.emoji-rating-selector.label-no-create',
		defaultMessage: 'Please rate your experience with Rovo:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for Rovo page editing.',
	},
	summaryTitle: {
		id: 'smart-create-feedback.summary-title',
		defaultMessage: 'Tell us more about your experience:',
		description:
			'Label for a freeform text field that allows the user to share feedback about their experience with Atlassian. Only appears in the feedback modal for the Create with Rovo feature.',
	},
	categoryTitle: {
		id: 'smart-create-feedback.category-title',
		defaultMessage: 'What category best describes your feedback? (optional)',
		description:
			'Label for a field that allows the user to select a category for their feedback.  Options are: "Performance", "Response quality", "User experience", "Other"',
	},
	categoryPerformance: {
		id: 'smart-create-feedback.category.performance',
		defaultMessage: 'Performance',
		description:
			'Category label for performance feedback.  Performance indicates "speed" (slow/fast) of the AI-generated response.',
	},
	categoryResponseQuality: {
		id: 'smart-create-feedback.category.response-quality',
		defaultMessage: 'Response quality',
		description:
			'Category label for response quality feedback.  Response quality indicates how good/bad or accurate/inaccurate the AI-generated response was.',
	},
	categoryUserExperience: {
		id: 'smart-create-feedback.category.user-experience',
		defaultMessage: 'User experience',
		description:
			'Category label for user experience feedback on the experience of creating AI-generated content.',
	},
	categoryOther: {
		id: 'smart-create-feedback.category.other',
		defaultMessage: 'Other',
		description: 'Category label for other feedback on AI-generated content creation.',
	},
});
